<template>
  <HeroSection theme="home/testimonials" class="bg-light">
    <div class="text-center mb-5">
      <h1 class="text-navy">Our customers can't stop raving about us...</h1>
    </div>
    <div class="row mb-4">
      <div v-for="item in latestTestimonials" :key="item.id" class="col-md-6 col-sm-6 col-xs-12 col-lg-3 mb-5">
        <div class="card">
          <div class="card-body">
            <div class="mb-auto">
              <h5>&quot;{{ item.headline }}&quot;</h5>
              <p class="font-size-1 mb-1">{{ item.comment }}</p>
              <h6 class="mb-1">{{ item.source }}</h6>
              <StarRating :rating="item.rating"></StarRating>
            </div>
          </div>
        </div>
      </div>
    </div>
  </HeroSection>
</template>

<script>
  import StarRating from "../StarRating";
  import HeroSection from "@/components/layout/HeroSection";
export default {
    name: "Testimonials",
    
    components: {
      HeroSection,
      StarRating
    },
  
    data() {
      return {
        testimonials: [
          {
            "id": 1,
            "source": "Janet, Glasgow",
            "headline": "Easy experience",
            "comment": "Simple and easy experience, keep you well informed about the progress of your application. Explain everything in easy terms and guide you all the way.",
            "rating": 5
          },
          {
            "id": 2,
            "source": "David, Manchester",
            "headline": "Best deal",
            "comment": "Amazing service from start to finish. Everything was clearly explained and I'm confident I got the best deal for me and my family.",
            "rating": 5
          },
          {
            "id": 3,
            "source": "Anna, London",
            "headline": "Communication has been great",
            "comment": "Communication has been great. No more than a couple of days between updates so I have know exactly what to expect from the process.",
            "rating": 5
          },
          {
            "id": 4,
            "source": "Stuart, Cardiff",
            "headline": "First class",
            "comment": "I was a bit nervous about using an online service, but I really had nothing to worry about, the service we received from start to finish was first class. I will be recommending to others without a doubt.",
            "rating": 5
          }
        ]
      }
    },
  
    computed: {
        latestTestimonials() {
          return this.testimonials == null ? [] : this.testimonials;
        }
    },
};
</script>
